import React, { useRef } from 'react';
import { Button, Icon } from 'audamatic-ui';
import Image from '@components/base_image/component';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import './styles.scss';

const ProductModal = (props) => {
  const { product } = props;
  const { frontImage, name, fallbackImage, images } = product;
  const { backImage, inlayImage } = images;
  const sliderRef = useRef(null);

  const imagesArray = [frontImage, backImage, inlayImage].filter(Boolean);
  const carrouselSettings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    arrows: false,
    draggable: false,
    swipe: false,
    fade: true,
    variableWidth: false,
  };

  const imgNext = () => {
    sliderRef.current.slickNext();
  };
  const imgPrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="product-modal">
      <section className="modal-header">
        {imagesArray.length > 1 && (
          <>
            <Button
              variant="tertiary"
              size="small"
              iconLeft={<Icon size="sm" name="NavArrowLeft"/>}
              onClick={imgPrevious}
            />
            <Button
              variant="tertiary"
              size="small"
              iconLeft={<Icon size="sm" name="NavArrowRight"/>}
              onClick={imgNext}
            />
          </>
        )}
      </section>
      <section className="slider-container">
        <Slider
          ref={sliderRef}
          {...carrouselSettings}
          className="product-slick-slider"
        >
          {imagesArray.map((image, index) => (
            <div key={index}>
              <Image alt={name} src={image} fallback={fallbackImage} />
            </div>
          ))}
        </Slider>
      </section>
    </div>
  );
};
ProductModal.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
};
export default ProductModal;
